import { createPluginFactory, RangeBeforeOptions } from '@udecode/plate-common';

import { ELEMENT_INTERLINK } from '../../plateTypes';
import { makeNodeId } from '../../utils/nodeId';
import { withMyLinks } from './withMyLinks';

export { ELEMENT_INTERLINK };

export interface InterlinkPlugin {
  /**
   * Allow custom config for rangeBeforeOptions.
   *
   * @example
   *   default
   *   {
   *   matchString: ' ',
   *   skipInvalid: true,
   *   afterMatch: true,
   *   }
   */
  rangeBeforeOptions?: RangeBeforeOptions;

  /** NOTE: Disabled for now. Hotkeys to trigger floating link. */
  // triggerFloatingLinkHotkeys?: string | string[];

  /**
   * Keeps selected text on pasting links by default.
   *
   * @default true
   */
  // keepSelectedTextOnPaste?: boolean;
}

/** Enables support for hyperlinks. */
export const createInterlinkPlugin = createPluginFactory<InterlinkPlugin>({
  key: ELEMENT_INTERLINK,
  isElement: true,
  isInline: true,
  withOverrides: withMyLinks,
  options: {
    rangeBeforeOptions: {
      matchString: ' ',
      skipInvalid: true,
      afterMatch: true,
    },
    // keepSelectedTextOnPaste: true,
  },
  then: () => ({
    deserializeHtml: {
      rules: [
        {
          validAttribute: 'data-elevio-article',
        },
      ],
      getNode(el, node) {
        const articleId = el.getAttribute('data-elevio-article');
        if (articleId) {
          return {
            id: makeNodeId(),
            type: ELEMENT_INTERLINK,
            linkId: `elevio-article-id:${articleId}`,
            linkType: 'article',
            linkTitle: '',
            ...node,
          };
        }
      },
    },
  }),
});
